export const TOOLTIP_DEFINITIONS = {
  prc_desc_ratio:
    '직전 상승장 최고가 대비 얼마나 떨어졌는지, 혹은 얼마나 덜 올랐는지를 보는 기준비율',
  gap: '매매 최저호가 − 전세 최저호가',
  type2_ratio: '전세 최저호가 ÷ 매매 최저호가 × 100',
  cross_size_bargain_upper:
    '상위 평형과 해당 평형 간 가격 차이가 10% 이하인 경우 (상위 평형 = 가성비 매물, 주황색 하이라이트)',
  cross_size_bargain_lower: '평형간 급매 쌍의 하위 평형 (파란색 하이라이트)',
};
